const _ = require("lodash");

// A bunch of utilities for detecting and dealing with overlapping points and
// edges. Intended to help deal with a list of faces specifying a 3D solid, but
// the functions here are written for vectors of any dimension.

// Return a vector as a string key. Points close enough to be the same will have
// the same keys.
const vToKey = v => v.map(x => x.toFixed(8)).join(",");

const edgeToKey = (v1, v2) => _.sortBy([vToKey(v1), vToKey(v2)]).join(";");

// Get list of vertices in vList1, order preserved, which are also in vList2.
const getCommonPoints = function(vList1, vList2) {
	const vTable2 = {};
	vList2.forEach(v => {
		vTable2[vToKey(v)] = v;
	});
	return vList1.filter(v => vTable2[vToKey(v)]);
};

// Given an array of faces (each an array of vertices), return an array of
// objects representing edges. Each object has keys:
// - vs: array of two vertices.
// - faceInds: array of indices, representing the faces that contain this edge.
//   The return indexes into the passed faces array. For typical solids, the
//   array will always have length 2.
const findAllEdges = function(faces) {
	const eList = []; // Return value.
	const eTable = {}; // Maps edge keys to eList index.
	// Helper to update the above two variables with an edge in a face.
	const addEdge = (v1, v2, faceInd) => {
		const key = edgeToKey(v1, v2);
		if (eTable.hasOwnProperty(key)) {
			eList[eTable[key]].faceInds.push(faceInd);
		} else {
			eTable[key] = eList.length;
			eList.push({vs: [v1, v2], faceInds: [faceInd]});
		}
	};
	faces.forEach((vs, faceInd) => {
		for (let i = 0; i < vs.length; i += 1) {
			const nextI = (i + 1) % vs.length;
			addEdge(vs[i], vs[nextI], faceInd);
		}
	});
	return eList;
};

module.exports = {
	vToKey,
	edgeToKey,
	getCommonPoints,
	findAllEdges,
};
